export default "/fonts/vendor/@fontsource/lato/files/lato-latin-ext-700-normal.woff2?9c8812eaec45956201e177b39d27a808";